
import { defineComponent, reactive } from 'vue'
import { useAgreementModule } from '@/modules/agreements'
import { useRoute } from 'vue-router'
import AgreementsFilter from '@/components/agreements/agreements-filter.vue'
import { AgreementsRouteNames } from '@/router/routes-names'
import { AgreementSearchFilter } from '@/views/_shared/search-list/types'
import { FormModelCacheTag, restoreFormModelTo } from '@/modules/_shared/forms'
import AgreementsList from '@/components/agreements/agreements-list.vue'

export default defineComponent({
    name: 'view-agreements-agreements',
    components: {
        AgreementsFilter,
        AgreementsList
    },
    props: {
        restoreFilters: {
            type: [Boolean, String]
        }
    },
    async setup (props) {
        const { getAgreements, agreements, agreementsFilter } = useAgreementModule()
        const route = useRoute()

        if (props.restoreFilters !== false) {
            restoreFormModelTo(agreementsFilter.search, FormModelCacheTag.AGREEMENTS_LIST_FILTERS)
        }

        let filter = agreementsFilter.search as AgreementSearchFilter
        filter = reactive(filter)

        function onResetFilters () {
            filter.id = ''
            filter.status = ''
            filter.type = ''
            filter.organization = ''
            filter.name = ''
            filter.dateFrom = ''
            filter.dateTo = ''
            filter.packageIds = []
        }

        await getAgreements()

        return {
            agreements,
            onResetFilters,
            filter,
            AgreementsRouteNames,
            route
        }
    }
})
